export default {
  tab: 'Feedback',
  toolbar: {
    markup: 'Mark up',
    record: 'Record',
    hint: 'Click to comment, drag to draw',
    hintTouch: "Drag to mark what's wrong",
    hintRecord: 'Recording your screen',
    exit: 'Exit',
  },
  popup: {
    about: 'About',
    placeholder: 'Describe the issue or suggestion...',
    submit: 'Submit',
    sending: 'Sending...',
    cancel: 'Cancel',
    close: 'Close',
    my_feedback: 'My feedback',
    screenshot_label: 'Attach screenshot',
    screenshot_hint: 'Passwords and other sensitive fields are covered automatically.',
    screenshot_short: 'Screenshot',
    screenshot_locked_hint: 'Your drawing is baked onto the screenshot, so it is always attached. Sensitive fields are covered automatically.',
    recording_label: 'Recording',
    recording_locked_hint: 'A replay of what the page showed and how it was used — always included with a recording. No camera or microphone. Sensitive fields are covered automatically.',
    quickOptions: [
      { emoji: '🐛', label: 'Broken', value: "Something's broken" },
      { emoji: '💡', label: 'Suggestion', value: 'I have a suggestion' },
      { emoji: '🤔', label: 'Confused', value: "I'm confused" },
    ],
  },
  success: {
    title: 'Thanks, your feedback is in.',
    title_no_ai: "Thanks! We've received your feedback.",
    close: 'Close',
    email_saved: "You'll get an email when it's resolved.",
    email_error: "Couldn't save your email. Please try again.",
    track_feedback: 'Track your feedback',
    email_cta: 'Email me when it\'s fixed',
    notify: 'Notify',
  },
  error: {
    submit: 'Failed to submit. Please try again.',
    finalize_title: "We couldn't send this yet.",
    finalize_message: 'Your feedback is still saved. Please try again.',
  },
  pet: {
    bubble: 'Need help?',
  },
  frustration: {
    prompt: 'Something not working? Tell us.',
    action: 'Annotate',
    dismiss: 'Dismiss',
  },
  annotation: {
    drawing: 'Drawing',
    element: 'element',
  },
  draw: {
    note_placeholder: 'Add a note to your drawing',
    undo: 'Undo',
    redo: 'Redo',
    cancel: 'Cancel',
    submit: 'Submit',
  },
  record: {
    stop: 'Stop',
    timer_label: 'Recording',
    max_reached: 'Maximum recording time reached',
    replay_label: 'screen-recording.json',
    play: 'Play recording',
    close: 'Close',
    preview_unavailable: 'Preview unavailable',
  },
  clarify: {
    title: 'Make This Better AI',
    subtitle: 'Sharpening your feedback',
    thinking: 'Thinking...',
    placeholder: 'Add details, then submit',
    send: 'Send',
    submit: 'Submit',
    send_feedback: 'Send feedback',
    skip: 'Skip & submit',
    skip_short: 'Skip',
    cancel: "Cancel — don't send feedback",
    retry: 'Retry',
    error: "Couldn't load the question. Send your feedback as is.",
    expired: 'This feedback session expired before it could be sent. Please close the widget and submit again.',
  },
}
